import React from "react";
import { Popover, Typography, Button, Box } from "@mui/material";

interface SharePopupProps {
    url: string;
    anchorEl: HTMLElement | null;
    onClose: () => void;
}

const SharePopup: React.FC<SharePopupProps> = ({ url, anchorEl, onClose }) => {
    const open = Boolean(anchorEl);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(url).then(() => {
            alert("URL copied to clipboard!");
        });
    };

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "center",
            }}
            sx={{
                "& .MuiPaper-root": {
                    width: "300px",
                    height: "100px",
                    overflow: "hidden", // Prevents scrolling
                },
            }}
        >
            <Box
                sx={{
                    p: 1.5, // Reduced padding
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                }}
            >
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontSize: "1rem",
                        mb: 0.5,
                    }}
                >
                    Share Profile
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            flexGrow: 1,
                            p: 1,
                            border: 1,
                            borderColor: "divider",
                            borderRadius: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            bgcolor: "action.hover",
                        }}
                    >
                        {url}
                    </Typography>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={copyToClipboard}
                        sx={{ minWidth: "fit-content" }}
                    >
                        Copy
                    </Button>
                </Box>
            </Box>
        </Popover>
    );
};

export default SharePopup;
